import React from "react";
import {ResponseData} from './panels/types/types';

export interface AdminProps {
    username: string | undefined;
    token: string | undefined
    isAdmin: boolean
    isViewer: boolean
    setModal: React.Dispatch<React.SetStateAction<boolean>>
    message: React.Dispatch<React.SetStateAction<{body: ResponseData}>>
    setCurrentForeningReportNumber: React.Dispatch<React.SetStateAction<number>>
}

export type Forening = {
    id?: number | null ,
    foreningsNummer: number,
    foreningsNavn: string,
    password: string,
    active: boolean,
    viewer: boolean,
    isAdmin?: boolean,
    handleChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
}
export type State = {
    foreningerSok: string,
    username: string | undefined,
    match: boolean,
    loading: boolean,
    currentForening: Forening,
    foreningList: Forening[],
    successful: boolean
}

export const initialState: State = {
    foreningerSok: '',
    username: '' ,
    match: false,
    loading: false,
    currentForening: {
        foreningsNummer: NaN,
        foreningsNavn: '',
        password: '',
        active: true,
        viewer: false
    },
    foreningList: [],
    successful: false
}

export type RegisterForeningData = {
    opprettForeningsNummer: number;
    opprettForeningsNavn: string;
    opprettForeningsPassord: string;
    active: boolean,
    viewer: boolean
    body?: string
}

export type Action = { type: 'setForeningerSok', payload: string }
    | { type: 'setCurrentForening', payload: Forening }
    | { type: 'setUsername', payload: string | undefined }
    | { type: 'setMatch', payload: boolean }
    | { type: 'setLoading', payload: boolean }
    | { type: 'setSuccessful', payload: boolean }
    | { type: 'setForeningList', payload: Forening[] }
